import { createContext, useContext } from "react";
import { useJWTTokenManager } from "../hooks/useJWTTokenManager";

const JWTContext = createContext(null);

/**
 * JWT Context Provider
 * Provides JWT token state to all child components
 * Token refresh happens on-demand when API calls are made
 * @param {boolean} enableInitialization - Whether to enable JWT initialization (lazy load)
 * @param {string} apiKey - Optional API key for customer domains
 */
export const JWTProvider = ({ children, enableInitialization = false }) => {
  const { isTokenInitialized, tokenError } =
    useJWTTokenManager(enableInitialization);

  return (
    <JWTContext.Provider
      value={{
        isTokenInitialized,
        tokenError,
      }}
    >
      {children}
    </JWTContext.Provider>
  );
};

/**
 * Hook to access JWT context
 * @returns {Object} JWT context value
 */
export const useJWTContext = () => {
  const context = useContext(JWTContext);

  if (!context) {
    throw new Error("useJWTContext must be used within JWTProvider");
  }

  return context;
};
